import {
  iconCommonProps, iconDefaultProps, iconPropTypes
} from '../propTypes';

const Previous = ({ className, color }) => (
  <svg
    className={ className }
    { ...iconCommonProps }
    viewBox='0 0 14.87 9.82'
  >
    <g>
      <polygon
        fill={ color }
        points='14.87 0 8.1 4.11 8.1 0 0 4.91 8.1 9.82 8.1 5.71 14.87 9.82 14.87 0'
      />
    </g>
  </svg>
);

Previous.propTypes = { ...iconPropTypes };

Previous.defaultProps = { ...iconDefaultProps };

export default Previous;